import {
  Spin, List, Button, Tag, Alert, Cascader, Input,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDebounceFn, useRequest } from 'ahooks';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import FixMenu from '@/components/FixMenu/FixMenu';
import EmptyImg from '@/components/EmptyImg/EmptyImg';
import { getPolicyCardList } from '@/services/policy';

import './index.less';
import FilterType from '@/components/FilterType/FilterType';
import { getDictType } from '@/services/common';
import {
  POLICY_CARD_SUPPORT_OBJECT, POLICY_CARD_TYPE, POLICY_MORE_TYPE, policyType,
} from '@/utils/mappingDict';
import DictionaryMatching from '@/components/DictionaryMatching/DictionaryMatching';

const startYear = 2024;
const endYear = new Date().getFullYear() + 1; // 当前年份
const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => {
  const item = { val: startYear + i, name: startYear + i };
  return item;
});

const defaultParams = [POLICY_CARD_TYPE, POLICY_MORE_TYPE, POLICY_CARD_SUPPORT_OBJECT].join(',');

export default function Index() {
  const Navigate = useNavigate();
  const area = useSelector((state) => state.area);
  const [val, setVal] = useState({});
  const [district, setDistrict] = useState('全部');

  const { data: dict = {} } = useRequest(getDictType, { // 筛选项字典
    defaultParams: [defaultParams],
  });

  const { data, loading, run } = useRequest(getPolicyCardList);

  const onPageChange = (pageNum) => {
    run({ pageNum, ...val });
  };

  function handleDetail(id) {
    Navigate(`/policy/detail?id=${id}`);
  }

  const handleFilter = (arr, type, isRadio) => {
    let target = isEmpty(arr) ? undefined : arr;
    if (target && isRadio) {
      // eslint-disable-next-line prefer-destructuring
      target = arr[0];
    }
    setVal({ ...val, [type]: target });
    run({ ...val, [type]: target });
  };

  const onChange = (e, target) => {
    const obj = { ...val };
    let text = district;
    if (e.length === 1) {
      obj.regionVo = {};
      text = '四川省';
    } else if (e.length === 2) {
      obj.regionVo = { cityCode: e[1] };
      text = target[1]?.name;
    } else {
      obj.regionVo = { cityCode: e[1], areaCode: e[2] };
      text = `${target[1]?.name}/${target[2]?.name}`;
    }
    setDistrict(text);
    setVal(obj);
    run(obj);
  };

  const { run: onSearchChange } = useDebounceFn(
    (v) => {
      const curVal = { ...val, title: v.target.value };
      setVal(curVal);
      run(curVal);
    },
    { wait: 500 },
  );

  return (
    <div className="policy-card">
      <div className="policy-card__banner">
        政策要点
      </div>
      <Spin spinning={loading}>
        <div className="content-width">
          <Alert message="市州及区县政策需登录后查看" type="info" showIcon className="policy-alert" />
          <div className="policy-list__filter">
            <div className="district-box">
              <div className="district-box_label">政策名称</div>
              <div className="district-box_input">
                <Input placeholder="请输入政策名称，支持模糊查询" onChange={(e) => onSearchChange(e)} />
              </div>
            </div>
            {
              !isEmpty(area) && (
                <div className="district-box">
                  <div className="district-box_label">区域</div>
                  <div>
                    <span className="district-box_val">{district}</span>
                    <Cascader
                      options={area}
                      onChange={onChange}
                      fieldNames={{ label: 'name', value: 'id', children: 'children' }}
                      changeOnSelect
                    >
                      <a href="#">请选择</a>
                    </Cascader>
                  </div>
                </div>
              )
            }
            <FilterType title="年度" titleWidth={60} data={years} radio onChange={(e) => handleFilter(e, 'year', true)} />
            <FilterType
              title="级别"
              radio
              titleWidth={60}
              data={dict[POLICY_CARD_TYPE]}
              onChange={(e) => handleFilter(e, 'moduleType', true)}
            />
            <FilterType
              title="政策类型"
              titleWidth={60}
              data={dict[POLICY_MORE_TYPE]}
              onChange={(e) => handleFilter(e, 'typeList')}
            />
            <FilterType
              title="支持对象"
              titleWidth={60}
              data={dict[POLICY_CARD_SUPPORT_OBJECT]}
              onChange={(e) => handleFilter(e, 'supportObjectList')}
            />
          </div>
          {
            isEmpty(data?.items) ? (
              <EmptyImg height={300} />
            ) : (
              <div className="policy-card__con">
                <List
                  loading={loading}
                  itemLayout="vertical"
                  dataSource={data?.items}
                  rowKey="id"
                  pagination={{
                    onChange: onPageChange,
                    current: data?.pageNum,
                    total: data?.totalRows,
                  }}
                  bordered={false}
                  renderItem={(item) => (
                    <List.Item
                      extra={(
                        <div style={{ marginTop: 33 }}>
                          <Button
                            className="policy-list_apply-btn"
                            key="detail"
                            type="primary"
                            onClick={() => {
                              handleDetail(item.id);
                            }}
                          >
                            查看
                          </Button>
                        </div>
                      )}
                      className="policy-list_item"
                    >
                      <List.Item.Meta
                        title={(
                          <div className="zczx__con-li-title">
                            <span className={policyType[item.module]?.class}>
                              <DictionaryMatching dictionary={dict[POLICY_CARD_TYPE]} value={item.module} />
                            </span>
                            <span>{item?.title}</span>
                          </div>
                        )}
                        description={(
                          <div className="sle">
                            支持对象：
                            {item.supportObjectName}
                          </div>
                        )}
                      />
                      <div style={{ display: 'flex' }}>
                        <Tag color="orange">
                          {item.year}
                          年度
                        </Tag>
                        <Tag color="red">
                          {item.areaName}
                        </Tag>
                      </div>
                    </List.Item>
                  )}
                />
              </div>
            )
          }
        </div>
      </Spin>
      <FixMenu />
    </div>
  );
}
